import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import AddItems from "./AddItems";

const ExpenseForm = ({ formDetails, optionItems, addDetails }) => {
  const [getinput, setGetinput] = useState([]);
  const validationSchema = Yup.object().shape({
    customerName: Yup.string().required("Name is required"),
    phone: Yup.string().required("Phone number is required"),
    exportDate: Yup.date().required("Export date is required"),
    billNo: Yup.string().required("Bill number is required"),
    address: Yup.string().required("Address is required"),
    panNo: Yup.string().required("Pan Number is required"),
    // items: Yup.string().required("Items is required"),
    // category: Yup.string().required("Category is required"),
    // rate: Yup.string().required("Rate Number is required"),
    // quantity: Yup.string().required("Quantity Number is required"),
  });

  const form = [
    {
      label: "Items",
      type: "select",
      apiKey: "items",
      options: [
        { label: "Item 1", value: "item1" },
        { label: "Item 2", value: "item2" },
        { label: "Item 3", value: "item3" },
      ],
    },
    {
      label: "Category",
      type: "select",
      apiKey: "category",
      options: [
        { label: "Category 1", value: "cat1" },
        { label: "Category 2", value: "cat2" },
        { label: "Category 3", value: "cat3" },
      ],
    },
    {
      label: "Rate",
      type: "text",
      apiKey: "rate",
    },
    {
      label: "Qty",
      type: "text",
      apiKey: "quantity",
    },
  ];

  // const [Move, setMove] = useState("");
  const Submit = (values) => {
    // console.log(getinput);
    values.allItemsCategory = getinput;
    // values.   category: getinput.category,
    // values   rate: getinput.rate,
  };
  return (
    <>
      <Formik
        initialValues={{
          customerName: "",
          phone: "",
          exportDate: "",
          billNo: "",
          address: "",
          panNo: "",
          allItemsCategory: "",
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          console.log(values);
          Submit(values);
        }}
      >
        {({ handleSubmit, errors, touched }) => (
          <Form className="w-full h-fit" onSubmit={handleSubmit}>
            <div className="grid grid-cols-3 gap-4 mb-4">
              <div className="grid col-span-2 grid-cols-3 gap-4  ">
                {formDetails.map((val, i) => {
                  return (
                    <div key={i} className="">
                      <fieldset className=" border-2 border-[#B0ACAC] rounded-lg ">
                        <legend
                          className="text-sm mx-2 px-2 font-medium"
                          htmlFor={val.label}
                        >
                          {val.label}
                          <span className="text-red-600">*</span>
                        </legend>
                        <Field
                          type={val.type}
                          id={val.id}
                          name={val.name}
                          className="w-full bg-transparent px-4 py-2 text-lg focus:outline-none"
                        />
                      </fieldset>
                      <ErrorMessage
                        name={val.name}
                        component="div"
                        className="text-red-500 text-xs mt-2"
                      />
                    </div>
                  );
                })}
              </div>

              <div className=" col-span-1">
                <fieldset className="mb-4 border-2 h-full border-[#B0ACAC] rounded-lg ">
                  <legend
                    className="text-xs mx-2 px-2 font-medium"
                    htmlFor="note"
                  >
                    Note
                  </legend>
                  <Field
                    as="textarea"
                    id="note"
                    name="note"
                    className="w-full h-full resize-none py-2  bg-transparent px-4 text-lg focus:outline-none"
                  />
                </fieldset>
                <ErrorMessage
                  name="note"
                  component="div"
                  className="text-red-500 text-xs mt-2"
                />
              </div>
            </div>
            <div className="p-5 rounded-xl my-20 border border-gray-500">
              <AddItems
                form={form}
                errors={errors}
                getinput={getinput}
                setGetinput={setGetinput}
                touched={touched}
              />
            </div>
            <div className="my-20 flex justify-start w-full">
              <button
                type="submit"
                className="bg-green-600 px-7 py-2 rounded-sm text-white"
              >
                Submit
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};
export default ExpenseForm;
